"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerToken = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("../../constants/index.js");
/**
 * @function getCustomerToken
 * @description Pega o token, de cliente identificado, dos cookies. O token é adicionado no momento
 * em que o cliente é reconhecido via Plataforma de Reconhecimento.
 */
const getCustomerToken = () => {
    const token = js_cookie_1.default.get(constants_1.CUSTOMER_TOKEN_KEY);
    return { hasCustomerToken: Boolean(token), customerToken: token };
};
exports.getCustomerToken = getCustomerToken;
